import {
  SHOW_CREATE_AUDIENCE_MODAL,
  HIDE_CREATE_AUDIENCE_MODAL,
  SHOW_EDIT_AUDIENCE_MODAL,
  SHOW_COMPARE_AUDIENCE_MODAL,
} from '../constants/action-types';

export const showCreateAudienceModal = () => ({
  type: SHOW_CREATE_AUDIENCE_MODAL,
});

export const showEditAudienceModal = queryBuilderProps => ({
  type: SHOW_EDIT_AUDIENCE_MODAL,
  queryBuilderProps,
});

export const showCompareAudienceModal = () => ({
  type: SHOW_COMPARE_AUDIENCE_MODAL,
});

export const hideCreateAudienceModal = () => ({
  type: HIDE_CREATE_AUDIENCE_MODAL,
});
